<div class="panel" [class.active]="toggle.checked">
  <app-form-switch
    labelPosition="before"
    [inline]="!toggle.checked || viewType === 'table'"
    [formControl]="form.get('status')"
    [matTooltip]="customTooltip || getTooltip()"
    [disabled]="(isEditing$ | async) || disabled"
    #toggle
  >
    {{ label }}
  </app-form-switch>
  <ng-container *ngIf="toggle.checked && viewType !== 'table'">
    <div class="d-flex gap-3 flex-wrap">
      <ng-container *ngIf="isTimeBasedEvent && isTimeEditable">
        <app-automation-time-options
          [form]="form"
          [showLabel]="false"
          class="d-flex gap-3"
        ></app-automation-time-options>
      </ng-container>
      <button class="btn btn-secondary-info" (click)="info.onEditReview()" [disabled]="isEditing$ | async">
        <i class="cs-icon cs-icon-pencil"></i>
        <ng-container i18n>Edit</ng-container>
      </button>
    </div>
  </ng-container>
</div>

<app-autopilot-automation-info
  [automationGroup]="automationGroup"
  [event]="event"
  [eventSourceType]="eventSourceType"
  [isSendReview]="true"
  [class.d-none]="viewType !== 'table'"
  #info
></app-autopilot-automation-info>
